export var METHODS = {
    policy: 'getCurrentConsentPolicy',
    header: '_getConsentPolicyHeader',
    isMethod: true,
};
export var PROPS_ACCESS = {
    policy: 'consentPolicy',
    header: 'consentPolicyHeader',
    isMethod: false,
};
export var ALLOW_ALL_POLICY = {
    essential: true,
    dataToThirdParty: true,
    advertising: true,
    functional: true,
    analytics: true,
};
//# sourceMappingURL=consts.js.map